import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "cevedem-theme"
const PREFERENCES = ["light", "dark"]
const LABELS = { light: "luminoasă", dark: "întunecată" }

export default class extends Controller {
  connect() {
    this.media = window.matchMedia("(prefers-color-scheme: dark)")
    this.preference = this.readPreference()
    this.handleSystemChange = () => !this.preference && this.apply()
    this.handleStorage = (event) => {
      if (event.key !== STORAGE_KEY) return
      this.preference = PREFERENCES.includes(event.newValue) ? event.newValue : null
      this.apply()
    }
    this.media.addEventListener("change", this.handleSystemChange)
    window.addEventListener("storage", this.handleStorage)
    this.apply()
  }

  disconnect() {
    this.media?.removeEventListener("change", this.handleSystemChange)
    window.removeEventListener("storage", this.handleStorage)
  }

  toggle() {
    this.preference = this.resolvedTheme() === "dark" ? "light" : "dark"
    try { localStorage.setItem(STORAGE_KEY, this.preference) } catch (_) {}
    this.apply()
  }

  synchronize() {
    this.preference = this.readPreference()
    this.apply()
  }

  readPreference() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      if (PREFERENCES.includes(saved)) return saved
    } catch (_) {}
    const bootstrapPreference = document.documentElement.dataset.themePreference
    return PREFERENCES.includes(bootstrapPreference) ? bootstrapPreference : null
  }

  resolvedTheme() {
    return this.preference || (this.media.matches ? "dark" : "light")
  }

  apply() {
    const resolved = this.resolvedTheme()
    document.documentElement.classList.toggle("dark", resolved === "dark")
    document.documentElement.dataset.themePreference = this.preference || "system"
    document.querySelector('meta[name="color-scheme"]').content = resolved
    const themeColor = document.querySelector('meta[name="theme-color"]')
    themeColor.content = themeColor.dataset[`${resolved}Color`]
    this.element.setAttribute("aria-checked", String(resolved === "dark"))
    this.element.title = this.preference
      ? `Temă: ${LABELS[resolved]}`
      : `Temă: sistem (${LABELS[resolved]})`
    window.dispatchEvent(new CustomEvent("theme:change", {
      detail: { resolvedTheme: resolved, preference: this.preference || "system" }
    }))
  }
}
